exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-search[data-v-58e6bb54]{color:var(--color-default);background:var(--background-default);border:none;border-radius:4px!important;padding:11px 46px;transition:.2s}.button-search[data-v-58e6bb54]:active,.button-search[data-v-58e6bb54]:hover{color:var(--color-hover-default);background:var(--background-hover-default)}.button-search>.button-validate>.button-label[data-v-58e6bb54]{font-weight:400;font-size:14px;line-height:130%;color:#fff}.button-loading>.button-validate>.button-spinner>div[data-v-58e6bb54]{margin-right:6.77px;height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-58e6bb54","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/buttons/btnDefault.vue
// module id = 561
// module chunks = 0